import React from 'react';
import styled from 'styled-components';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { StarRating } from 'components/reviews/star-rating';

type ProductCardRatingProps = {
  avgRating?: number | null;
  reviewCount?: number | null;
  className?: string;
};

export const PRODUCT_CARD_RATING_TEST_ID = 'product-card-rating';

/**
 * Stars + review count shown on product cards, gated by the
 * `growth.ecomm.consumer-product-reviews.rollout` LaunchDarkly flag.
 * Renders nothing when the flag is off or the product has no reviews.
 */
export const ProductCardRating = ({
  avgRating,
  reviewCount,
  className,
}: ProductCardRatingProps): JSX.Element | null => {
  const flags = useFlags();
  const enabled = !!flags['growth.ecomm.consumer-product-reviews.rollout'];

  if (!enabled || !reviewCount || reviewCount <= 0) {
    return null;
  }

  return (
    <Row className={className} data-testid={PRODUCT_CARD_RATING_TEST_ID}>
      <StarRating value={avgRating ?? 0} size={14} />
      <Count>{reviewCount}</Count>
    </Row>
  );
};

const Row = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
`;

const Count = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey[45]};
`;
